import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=129eda7d&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('129eda7d')) {
      api.createRecord('129eda7d', component.options)
    } else {
      api.reload('129eda7d', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=129eda7d&", function () {
      api.rerender('129eda7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y8fNzgd9weJ3/JS/comp/childrenage.vue"
export default component.exports